import { HttpClient } from '@angular/common/http';
import {Injectable} from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {NotificationConfig, NotificationService, NotificationStatus} from '../notification/notification.service';

export class VersionDetails {
    'git.commit.id': string;
    'git.commit.id.abbrev': string;
    'git.build.version': string;
    'git.build.version.raw': string;
}

@Injectable({
  providedIn: 'root'
})
export class UtilsService {

    constructor(public notificationService: NotificationService, public http: HttpClient) {
    }

    copy(data, successConfig?: NotificationConfig) {
        if (navigator.clipboard) {
            navigator.clipboard.writeText(data).then(() => {
                this.notifySuccessfulCopy(successConfig);
            });
        } else {
            console.log('Browser does not support Clipboard API');

            const el = document.createElement('textarea');  // Create a <textarea> element
            el.value = data;                                         // Set its value to the string that you want copied
            el.setAttribute('readonly', '');     // Make it readonly to be tamper-proof
            el.style.position = 'absolute';
            el.style.left     = '-9999px';                           // Move outside the screen to make it invisible

            document.body.appendChild(el);                           // Append the <textarea> element to the HTML document

            const selected =
                document.getSelection().rangeCount > 0           // Check if there is any content selected previously
                    ? document.getSelection().getRangeAt(0)    // Store selection if found
                    : false;                                         // Mark as false to know no selection existed before

            el.select();                                             // Select the <textarea> content
            document.execCommand('copy');                 // Copy - only works as a result of a user action (e.g. click events)
            document.body.removeChild(el);                           // Remove the <textarea> element

            if (selected) {                                          // If a selection existed before copying
                document.getSelection().removeAllRanges();             // Unselect everything on the HTML document
                document.getSelection().addRange(selected);            // Restore the original selection
            }

            this.notifySuccessfulCopy(successConfig);
        }
    }

    notifySuccessfulCopy(successConfig: NotificationConfig) {
        this.notificationService.notify(successConfig ? successConfig : {
            announcementMessage: 'Value copied to clipboard.',
            status: NotificationStatus.SUCCESS
        });
    }

    download(data: string, filename: string) {
        const element = document.createElement('a');
        element.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(data));
        element.setAttribute('download', filename);

        element.style.display = 'none';
        document.body.appendChild(element);

        element.click();

        document.body.removeChild(element);
    }

    getCommitId(): Observable<string>{
        return this.getVersionDetails().pipe(map((hash: VersionDetails) => hash['git.commit.id']));
    }

    getReleaseVersion(): Observable<string>{
        return this.getVersionDetails().pipe(map((hash: VersionDetails) => hash['git.build.version.raw']));
    }

    getVersionDetails(): Observable<VersionDetails> {
        return this.http.get<VersionDetails>('/assets/version.json');
    }
}
